import { render, staticRenderFns } from "./Crash.vue?vue&type=template&id=f95fe468&scoped=true&"
import script from "./Crash.vue?vue&type=script&lang=js&"
export * from "./Crash.vue?vue&type=script&lang=js&"
import style0 from "./Crash.vue?vue&type=style&index=0&id=f95fe468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95fe468",
  null
  
)

export default component.exports